import { IntlProvider } from 'react-intl';
import { Provider as ReactReduxProvider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import { browserHistory, hashHistory, Router } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';

import { Provider as DsxProvider } from '@dsx/react';
import { DndProvider } from '@duel/data-table';
import type { Store } from '@reduxjs/toolkit';
import { supportsHistory } from 'history/lib/DOMUtils';
import { sendPageView } from '../analytics';
import type { ILocaleMessages } from '../messages';

import './CommonStyles';

interface CommonProviderProps {
	localeMessages: ILocaleMessages;
	store: Store<any>;
	routes: any;
}

export function CommonProvider(props: CommonProviderProps) {
	const { localeMessages, store, routes } = props;

	const historyType = supportsHistory() ? browserHistory : hashHistory;
	const history = syncHistoryWithStore(historyType, store);

	return (
		<DndProvider>
			<IntlProvider
				locale={localeMessages.locale}
				messages={localeMessages.messages}
			>
				<ReactReduxProvider store={store}>
					<DsxProvider locale="en-US">
						<div className="react-root">
							<Router history={history} onUpdate={sendPageView}>
								{routes}
							</Router>
							<ReduxToastr
								timeOut={5000}
								newestOnTop={true}
								preventDuplicates={true}
								position="bottom-left"
								transitionIn="fadeIn"
								transitionOut="fadeOut"
								progressBar={false}
							/>
						</div>
					</DsxProvider>
				</ReactReduxProvider>
			</IntlProvider>
		</DndProvider>
	);
}
